export class UnsupportedWholeOrderPromotionSelector extends Error {
    constructor(cartPromotionRequirement) {
        super(`Unsupported WholeOrderPromotionSelector: ${cartPromotionRequirement.tag}`);
    }
}
